import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { history } from '../../../store';

class BannerCarouselButton extends Component {
  getButtonStyle = (hover) => {
    const { buttonColor, buttonTextColorWhenHover } = this.props;
    const hoveredButtonStyle = {
      color: buttonTextColorWhenHover,
      backgroundColor: buttonColor,
      borderColor: buttonColor,
    };
    const transparentButtonStyle = {
      color: buttonColor,
      backgroundColor: 'transparent',
      borderColor: buttonColor,
    };

    return hover ? {...hoveredButtonStyle} : {...transparentButtonStyle};
  };

  hoverOn = () => {
    this.updateCssVars(true);
  };

  hoverOff = () => {
    this.updateCssVars(false);
  };

  componentDidMount() {
    this.updateCssVars(false);
  }

  updateCssVars(hover) {
    const { key } = this.props;
    const refName = `carouselButton${key}`;
    if (this.refs[refName]) {
      const buttonStyle = this.getButtonStyle(hover);
      this.refs[refName].style.setProperty('--button-style-color', buttonStyle.color);
      this.refs[refName].style.setProperty('--button-style-background-color', buttonStyle.backgroundColor);
      this.refs[refName].style.setProperty('--button-style-border-color', buttonStyle.borderColor);
    }
  }


  render() {
    const { buttonLabel, buttonLink, buttonColor, key } = this.props;
    const refName = `carouselButton${key}`;
    const buttonClass = ['Red', 'Yellow', 'White', 'Grey'].includes(buttonColor) ? `${buttonColor.toLowerCase()}-ghost-btn` : 'red-ghost-btn'

    return (
      <div ref={refName}>
        <Button
          className={`${buttonClass} button-style`}
          onMouseEnter={this.hoverOn}
          onMouseLeave={this.hoverOff}
          onClick={() => {
            if (buttonLink.match(/^https?:.*/i)) {
              window.open(buttonLink, '_blank');
            } else {
              history.push(buttonLink);
            }
          }}
      >
        {buttonLabel}
      </Button>
      </div>
    );
  }
}

export default BannerCarouselButton;



// WEBPACK FOOTER //
// ./src/components/home/banner-carousel/banner-carousel-button.jsx